import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import NotFoundPage from '@/views/NotFoundPage.vue';
import ImprintPage from './views/ImprintPage.vue';
import PrivacyPolicyPage from '@/views/PrivacyPolicyPage.vue';
import ScamInfoView from '@/views/ScamInfoView.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/impressum', component: ImprintPage },
  { path: '/datenschutz', component: PrivacyPolicyPage },
  { path: '/scam-info', component: ScamInfoView },
  { path: '/:pathMatch(.*)*', component: NotFoundPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, behavior: 'smooth' };
  }
});

router.beforeEach((to) => {
  if (to.path !== '/') return true;
  if (to.query.legit !== undefined) return true;
  if (to.query.ved === undefined) return true;

  return { path: '/scam-info', replace: true };
});

export default router;
